import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'irembogov-irembogov-formly-attachment',
  templateUrl: './irembogov-formly-attachment.component.html',
  styleUrls: ['./irembogov-formly-attachment.component.scss'],
})
export class IrembogovFormlyAttachmentComponent extends FieldType<FieldTypeConfig> {}
